import { Table } from "antd"
import { useEffect, useState } from "react"
import "./index.scss"

function getWidth(list) {
  let total = 0
  for (const item of list) {
    if (item.width) total += item.width
    if (item.minWidth) total += item.minWidth
  }
  return total
}

export default function MyTable({
  columns,
  yHead = 340,
  notScrollY = false,
  rowKey = "id",
  onChange,
  pagination = false,
  ...rest
}) {
  const [scroll, setScroll] = useState()

  function handleTableChange(newPagination, filters, sorter) {
    if (onChange) onChange(newPagination, filters, sorter)
  }

  useEffect(() => {
    const scrollY = window.innerHeight - yHead
    const __scroll = { x: getWidth(columns), y: notScrollY ? undefined : scrollY }
    setScroll(__scroll)
  }, [columns, yHead, notScrollY])

  return (
    <Table
      size="small"
      bordered
      rowKey={(r) => r[rowKey]}
      pagination={pagination}
      scroll={scroll}
      columns={columns}
      onChange={handleTableChange}
      {...rest}
    />
  )
}
